var _classCallCheck = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OldValue = require('../old-value');

var Value = require('../value');

var Pixelated = /*#__PURE__*/function (_Value) {
  "use strict";

  _inherits(Pixelated, _Value);

  var _super = _createSuper(Pixelated);

  function Pixelated() {
    _classCallCheck(this, Pixelated);

    return _super.apply(this, arguments);
  }

  _createClass(Pixelated, [{
    key: "replace",
    value:
    /**
     * Use non-standard name for WebKit and Firefox
     */
    function replace(string, prefix) {
      if (prefix === '-webkit-') {
        return string.replace(this.regexp(), '$1-webkit-optimize-contrast');
      }

      if (prefix === '-moz-') {
        return string.replace(this.regexp(), '$1-moz-crisp-edges');
      }

      return _get(_getPrototypeOf(Pixelated.prototype), "replace", this).call(this, string, prefix);
    }
    /**
     * Different name for WebKit and Firefox
     */

  }, {
    key: "old",
    value: function old(prefix) {
      if (prefix === '-webkit-') {
        return new OldValue(this.name, '-webkit-optimize-contrast');
      }

      if (prefix === '-moz-') {
        return new OldValue(this.name, '-moz-crisp-edges');
      }

      return _get(_getPrototypeOf(Pixelated.prototype), "old", this).call(this, prefix);
    }
  }]);

  return Pixelated;
}(Value);

Pixelated.names = ['pixelated'];
module.exports = Pixelated;